import type { AccommodationAllocationInput } from '@data-access/graphql/schema.types'
import { type PaxParams, paxParser } from '@feat/feat-url-state/pax'

export function mapAccommodationPaxInput(pax: PaxParams): AccommodationAllocationInput[] {
  if (pax.allocation) {
    return pax.allocation.map(allocation => ({
      adultCount: allocation.adults,
      childrenAges: allocation.children,
    }))
  }

  return [
    {
      adultCount: pax.adults ?? paxParser.adults.defaultValue,
      childrenAges: pax.children ?? paxParser.children.defaultValue,
    },
  ]
}
